import { filterNullishFromObject } from "@ch/helpers/utils";
import type { BotChatProps, TKemMessagePayload } from "./types";

interface GetKemChatPayloadToSendOptions {
  excludeMessage?: boolean;
}

const getKemChatPayloadToSend = (
  props: Partial<TKemMessagePayload>,
  options?: GetKemChatPayloadToSendOptions,
) => {
  const propsToSend: BotChatProps = {
    ...props,
    exercise_duration_last_30_days: props.exercise_duration_last_30_days
      ? Number(props.exercise_duration_last_30_days)
      : undefined,
    latest_bmi: props.latest_bmi ? Number(props.latest_bmi) : undefined,

    // These fields are not needed to be sent to the backend
    user_picture: undefined,
    user_full_name: undefined,
    resource_url: undefined,
    seen: undefined,
    health_coach_name: undefined,
    action_plan: undefined,
    summarized_notes: undefined,
    ...(options?.excludeMessage ? { message: undefined } : {}),
  };

  return filterNullishFromObject(propsToSend);
};

export default getKemChatPayloadToSend;
